// components/ModelSelector.js
import React from 'react';
import { Cpu } from 'lucide-react';
import { AI_MODELS, AI_PROVIDERS } from '../constants/aiConstants';

const ModelSelector = ({ selectedModel, onModelChange, disabled = false }) => {
  // Group models by provider for the dropdown
  const openaiModels = AI_MODELS.filter(model => model.provider === AI_PROVIDERS.OPENAI);
  const anthropicModels = AI_MODELS.filter(model => model.provider === AI_PROVIDERS.ANTHROPIC);
  const googleModels = AI_MODELS.filter(model => model.provider === AI_PROVIDERS.GOOGLE);

  return (
    <div className={`mb-2 ${disabled ? 'opacity-60' : ''}`}>
      <label className="block text-sm font-medium mb-1 flex items-center gap-2">
        <Cpu className="w-4 h-4" />
        AI Model
        {disabled && <span className="text-gray-500 text-xs ml-2">(View Only)</span>}
      </label>

      <select
        value={selectedModel}
        onChange={(e) => !disabled && onModelChange(e.target.value)}
        className={`w-full p-2 border rounded ${disabled ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'}`}
        disabled={disabled}
      >
        {/* OpenAI Models */}
        <optgroup label="OpenAI Models">
          {openaiModels.map((model) => (
            <option key={model.id} value={model.id}>
              {model.name} - {model.description}
            </option>
          ))}
        </optgroup>
        
        {/* Anthropic Models */}
        <optgroup label="Anthropic Models">
          {anthropicModels.map((model) => (
            <option key={model.id} value={model.id}>
              {model.name} - {model.description}
            </option>
          ))}
        </optgroup>
        
        {/* Google Models */}
        <optgroup label="Google Models">
          {googleModels.map((model) => (
            <option key={model.id} value={model.id}>
              {model.name} - {model.description}
            </option>
          ))}
        </optgroup>
      </select>
      
      <p className="text-xs text-gray-500 mt-1">
        {disabled
          ? "View Only Mode - Model selection is not editable"
          : "Select a model based on your needs. More advanced models may take longer but produce better results."}
      </p>
    </div>
  );
};

export default ModelSelector;